<template>
  <ExternalQueryList
      headline="Registration Categories"
      endpoint="/api/v2/content-registration-categories"
      :endpoint-filters="{portal_id: portal.id}"
      :headlines="headlines"
      :filters="filters"
      :can-destroy="() => true"
      :can-update="() => true"
      :checkbox-column-width="2"
      :button-column-width="2"
      @show="contentRegistrationCategory => $router.push(getUrl(contentRegistrationCategory))"
  >
    <template v-slot:default="{ row: contentRegistrationCategory }">
      <td>
        <router-link :to="getUrl(contentRegistrationCategory)">
          {{ contentRegistrationCategory.attributes.name }}
        </router-link>
      </td>
    </template>

    <template v-slot:headline-right>
      <router-link
          class="btn btn-white btn-sm"
          style="margin-top: 4px;"
          :to="'/portals/' + portal.id + '/content/registration-categories/create'"
      >
        <i class="fa fa-plus"></i> Create
      </router-link>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'

export default {
  components: {ExternalQueryList},

  props: {
    portal: {
      required: true
    }
  },

  computed: {
    headlines() {
      return [
        {width: 20, text: 'Name'},
      ]
    },

    filters() {
      return [
        [
          {
            width: 20,
            widget: 'text',
            name: 'search',
            placeholder: 'Search...'
          },
          {
            width: 4,
            widget: 'submit'
          }
        ]
      ]
    }
  },

  methods: {
    getUrl(contentRegistrationCategory) {
      return '/portals/' + this.portal.id + '/content/registration-categories/' + contentRegistrationCategory.id + '/edit'
    }
  }
}
</script>
